import { API } from 'constants/api-endpoints';

import { tokenInstance } from 'lib/axios/instance';

export const deleteAvatarFile = async (id) =>
  await tokenInstance.delete(`${API.AVATAR_FILES}/delete`, {
    data: { id },
  });
